function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
/**
 * Poor-man's Faucet wallet. Keys in app.options.faucet.
 * slips[] are rebuilt from getBalanceSnapshot; the chain is the source of truth.
 *
 * WASM Transaction.sign() always signs with the node wallet key. Faucet
 * signs the canonical WASM hash_for_signature with the Faucet private key.
 */

var Transaction = require('../../../lib/saito/transaction')["default"];
var Slip = require('../../../lib/saito/slip')["default"];
var LOW_BALANCE_THRESHOLD = 2001n * 100000000n;
function outputIndexes(tx) {
  return (tx.to || []).map(function (slip) {
    return Number(slip.index);
  });
}
function slipTotal() {
  var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var total = 0n;
  var _iterator = _createForOfIteratorHelper(slips),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      try {
        total += BigInt(slip.amount || 0);
      } catch (err) {
        // ignore malformed slip amounts
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return total;
}
var FaucetWallet = /*#__PURE__*/function () {
  function FaucetWallet(app, mod) {
    _classCallCheck(this, FaucetWallet);
    this.app = app;
    this.mod = mod;
    this.queue = [];
    this.slips = [];
    this.publickey = '';
    this.halted = false;
  }
  return _createClass(FaucetWallet, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var faucet;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!this.app.options.faucet || _typeof(this.app.options.faucet) !== 'object') {
                this.app.options.faucet = {};
              }
              faucet = this.app.options.faucet;
              if (!faucet.publickey || !faucet.privatekey) {
                faucet.privatekey = this.app.crypto.generateKeys();
                faucet.publickey = this.app.crypto.generatePublicKey(faucet.privatekey);
                this.app.storage.saveOptions();
              }
              this.publickey = faucet.publickey;
              _context.n = 2;
              return this.getSnapshotBalance();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "queuePayment",
    value: function queuePayment(_ref) {
      var _this = this;
      var publickey = _ref.publickey;
      return new Promise(function (resolve, reject) {
        _this.queue.push({
          publickey: publickey,
          amount: _this.mod.amount,
          resolve: resolve,
          reject: reject
        });
        _this.addPayment('queued');
      });
    }
  }, {
    key: "addPayment",
    value: function () {
      var _addPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this,
          _this$app$wallet;
        var reason,
          slips,
          job,
          recipient_public_key,
          payout,
          available,
          fee,
          tx,
          _args2 = arguments,
          _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              reason = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              if (!(this.app.BROWSER || this.halted)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              slips = this.slips.filter(function (slip) {
                return String(slip.publicKey || '') === _this2.publickey && BigInt(slip.amount || 0) > 0n;
              });
              job = this.queue[0];
              recipient_public_key = job ? job.publickey : '';
              payout = job ? this.mod.amount : 0n;
              available = slipTotal(slips);
              fee = BigInt(((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.default_fee) || 0);
              if (!(!job && slips.length < 2)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (!(job && available < payout + fee)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              tx = this.createTransaction(slips, recipient_public_key);
              if (tx) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              _context2.p = 4;
              _context2.n = 5;
              return this.app.network.propagateTransaction(tx);
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              return _context2.a(2);
            case 7:
              this.halted = true;
              if (job) {
                this.queue.shift();
                job.resolve(tx);
                this.notifyLowBalance(tx);
              }
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 6]]);
      }));
      function addPayment() {
        return _addPayment.apply(this, arguments);
      }
      return addPayment;
    }()
  }, {
    key: "notifyLowBalance",
    value: function notifyLowBalance(tx) {
      var _this3 = this;
      try {
        // All faucet inputs are spent together. Its outputs are the remaining
        // balance after payout and fee; the snapshot still contains spent inputs.
        var remaining = slipTotal((tx.to || []).filter(function (slip) {
          return slip.publicKey === _this3.publickey;
        }));
        if (remaining >= LOW_BALANCE_THRESHOLD) {
          return;
        }
        var balance = this.app.wallet.convertNolanToSaito(remaining);
        this.app.connection.emit('mailrelay-send-email', {
          to: 'faucet@saito.io',
          from: 'Saito Faucet <network@saito.tech>',
          subject: "Faucet low balance: ".concat(balance, " SAITO remaining"),
          text: ['The faucet has broadcast a payment and its remaining balance is below 2001 SAITO.', '', "Faucet public key: ".concat(this.publickey), "Remaining balance after payment and fee: ".concat(balance, " SAITO"), "Payment transaction: ".concat(tx.signature)].join('\n'),
          ishtml: false
        });
      } catch (err) {
        console.error('[Faucet] failed to request low-balance email', err);
      }
    }

    /**
     * Build and sign one Faucet transaction from the given slips.
     * Recipient present → payout + change. No recipient → merge to Faucet.
     */
  }, {
    key: "createTransaction",
    value: function createTransaction() {
      var _this$app$options$fau, _this$app$options$fau2, _this$app$wallet2;
      var slips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var recipient_public_key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (this.app.BROWSER) {
        return null;
      }
      var faucet_publickey = this.publickey || ((_this$app$options$fau = this.app.options.faucet) === null || _this$app$options$fau === void 0 ? void 0 : _this$app$options$fau.publickey) || '';
      var faucet_privatekey = ((_this$app$options$fau2 = this.app.options.faucet) === null || _this$app$options$fau2 === void 0 ? void 0 : _this$app$options$fau2.privatekey) || '';
      if (!faucet_publickey || !faucet_privatekey || !slips.length) {
        return null;
      }
      var total_in = 0n;
      var _iterator2 = _createForOfIteratorHelper(slips),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;
          if (String(row.publicKey || '') !== faucet_publickey) {
            return null;
          }
          total_in += BigInt(row.amount || 0);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var fee = BigInt(((_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.default_fee) || 0);
      var payout = recipient_public_key ? this.mod.amount : 0n;
      if (total_in < payout + fee) {
        return null;
      }
      var change = total_in - payout - fee;
      var tx = new Transaction();
      tx.timestamp = Date.now();
      tx.txs_replacements = 1;
      tx.msg = recipient_public_key ? {
        module: 'Faucet',
        request: 'faucet issuance'
      } : {};
      var _iterator3 = _createForOfIteratorHelper(slips),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _row = _step3.value;
          var input = new Slip();
          input.publicKey = _row.publicKey;
          input.amount = BigInt(_row.amount);
          input.blockId = BigInt(_row.blockId);
          input.txOrdinal = BigInt(_row.txOrdinal);
          input.index = Number(_row.index);
          input.type = Number(_row.type) || 0;
          tx.addFromSlip(input);
        }

        // WASM tx.to returns copies, so indexes must be set on the Slip
        // before addToSlip clones it into the transaction.
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var output_index = 0;
      if (recipient_public_key) {
        var paid = new Slip();
        paid.publicKey = recipient_public_key;
        paid.amount = payout;
        paid.type = 0;
        paid.index = output_index++;
        tx.addToSlip(paid);
      }
      if (change > 0n || !recipient_public_key) {
        var rest = new Slip();
        rest.publicKey = faucet_publickey;
        rest.amount = change;
        rest.type = 0;
        rest.index = output_index++;
        tx.addToSlip(rest);
      }
      try {
        tx.packData();
        var assigned = [];
        for (var i = 0; i < output_index; i++) {
          assigned.push(i);
        }
        var reread = outputIndexes(tx);
        if (reread.join(',') !== assigned.join(',')) {
          return null;
        }
        tx.generateHashForSignature();
        var digest = Buffer.from(tx.getHashForSignature());
        if (digest.length !== 32) {
          return null;
        }
        var secp256k1 = require('secp256k1');
        var priv = Buffer.from(faucet_privatekey, 'hex');
        var signed = secp256k1.sign(digest, priv);
        tx.signature = Buffer.from(signed.signature).toString('hex');
        return tx;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "getSnapshotBalance",
    value: function () {
      var _getSnapshotBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$app$options$fau3;
        var publickey, loaded, S, saito, snapshot, rows, slips, _iterator4, _step4, row, cols, _t2, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              publickey = this.publickey || ((_this$app$options$fau3 = this.app.options.faucet) === null || _this$app$options$fau3 === void 0 ? void 0 : _this$app$options$fau3.publickey);
              if (publickey) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.p = 2;
              loaded = require('saito-js/saito');
              S = loaded["default"] || loaded;
              saito = typeof S.getInstance === 'function' ? S.getInstance() : null;
              if (!(!saito || typeof saito.getBalanceSnapshot !== 'function')) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _context3.n = 4;
              return saito.getBalanceSnapshot([publickey]);
            case 4:
              snapshot = _context3.v;
              rows = snapshot === null || snapshot === void 0 ? void 0 : snapshot.rows;
              slips = [];
              if (!(rows && typeof rows[Symbol.iterator] === 'function')) {
                _context3.n = 12;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(rows);
              _context3.p = 5;
              _iterator4.s();
            case 6:
              if ((_step4 = _iterator4.n()).done) {
                _context3.n = 9;
                break;
              }
              row = _step4.value;
              cols = String(row || '').trim().split(/\s+/);
              if (!(cols.length < 6 || cols[0] !== publickey)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(3, 8);
            case 7:
              slips.push({
                publicKey: cols[0],
                blockId: cols[1],
                txOrdinal: cols[2],
                index: Number(cols[3]),
                amount: cols[4],
                type: Number(cols[5])
              });
            case 8:
              _context3.n = 6;
              break;
            case 9:
              _context3.n = 11;
              break;
            case 10:
              _context3.p = 10;
              _t2 = _context3.v;
              _iterator4.e(_t2);
            case 11:
              _context3.p = 11;
              _iterator4.f();
              return _context3.f(11);
            case 12:
              this.slips = slips;
              if (!(!this.halted && this.queue.length)) {
                _context3.n = 13;
                break;
              }
              _context3.n = 13;
              return this.addPayment('snapshot');
            case 13:
              _context3.n = 15;
              break;
            case 14:
              _context3.p = 14;
              _t3 = _context3.v;
            case 15:
              return _context3.a(2);
          }
        }, _callee3, this, [[5, 10, 11, 12], [2, 14]]);
      }));
      function getSnapshotBalance() {
        return _getSnapshotBalance.apply(this, arguments);
      }
      return getSnapshotBalance;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blk, lc) {
        var was_halted;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this.app.BROWSER || !lc)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              was_halted = this.halted;
              _context4.n = 2;
              return this.getSnapshotBalance();
            case 2:
              if (!was_halted) {
                _context4.n = 3;
                break;
              }
              this.halted = false;
              if (!(this.queue.length || this.slips.length > 1)) {
                _context4.n = 3;
                break;
              }
              _context4.n = 3;
              return this.addPayment('new block');
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onNewBlock(_x, _x2) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "onChainReorganization",
    value: function onChainReorganization(_block_id, _block_hash, _lc) {
      if (this.app.BROWSER) {
        return;
      }
      this.halted = true;
    }
  }]);
}();
module.exports = FaucetWallet;